const PLACEHOLDER_DOMAINS = ['example.com', 'example.org', 'example.net', 'example', 'test', 'invalid'];

export function getPaymentRedirectTarget(
    target: string | null | undefined,
    currentUrl: string,
): string | null {
    if (!target?.trim()) return null;

    try {
        const destination = new URL(target);
        const current = new URL(currentUrl);
        if (!['https:', 'http:'].includes(destination.protocol)) return null;

        const hostname = destination.hostname.toLowerCase().replace(/\.$/, '');
        if (PLACEHOLDER_DOMAINS.some(
            domain => hostname === domain || hostname.endsWith(`.${domain}`),
        )) return null;

        // Query strings and fragments do not identify a different payment page.
        if (destination.origin === current.origin &&
            destination.pathname.replace(/\/+$/, '') === current.pathname.replace(/\/+$/, '')) {
            return null;
        }
        return destination.href;
    } catch {
        return null;
    }
}
